<div style="font-size: 12px; color: white; background: #171717;   padding: 15px 0px;">
  <div style="display: -webkit-flex;flex-direction: column;align-items: center;">
    <h1>MY TICKETS</h1>
    <div *ngIf="(spotlightsTickets.length === 0 && showcaseTickets.length === 0 && screeningPartiesTickets.length === 0) && !isLoading">
      <p>No Tickets Available..</p>
    </div>
    <div class="tickets_container" *ngIf="(spotlightsTickets.length !== 0 || showcaseTickets.length !== 0 || screeningPartiesTickets.length !== 0) && !isLoading">
      <h2 *ngIf="spotlightsTickets.length > 0|| screeningPartiesTickets.length > 0">Live Events</h2>
      <div *ngIf="spotlightsTickets.length > 0" style="flex-shrink:0;display:-webkit-flex; flex-wrap: wrap;width: 100%;justify-content: space-around;">
        <div *ngFor="let ticket of spotlightsTickets; let i = index;" style="display: -webkit-flex; flex-direction: column; padding: 15px;width: 325px;margin-bottom: 15px;">
          <div class="ticket_container" (click)="selectTicket('spotlights', ticket)">
            <div class="bd-border_dotted"></div>
            <div class="order-number-container">
              <div class="order-number">{{ ticket.OrderID }}</div>
            </div>
            <div class="bd-border_solid"></div>
            <div style="font-weight: bold;">{{ ticket.Name }}</div>
            <div style="font-size: 10px; margin-top: 5px">
              <p>Spotlight</p>
            </div>
            <div style="font-size: 10px; margin-top: 5px">
              Venue -
              <p>{{ ticket.VenueName }}</p>
            </div>
            <div style="font-size: 10px;">
              <p>{{ ticket.StartDateTime+pacificTimezone(ticket.StartDateTime) | date:'medium' }} {{userTimezoneName(ticket.StartDateTime)}}</p>
            </div>
          </div>
          <div style="align-self: center;">
            <a href="/cinejoy/premiere/upcoming">Spotlights</a>
          </div>
        </div>
      </div>
      <div *ngIf="showcaseTickets.length > 0" class="showcase-heading">
        <h2>Showcase Movies</h2>
        <h5>All Showcase Movies can be watched during the Cinejoy Festival, occurring March 21, 2024- March 31,  
          2024. You have 48 hours to complete your screening.</h5>
      </div>
      <div style="flex-shrink:0;display:-webkit-flex; flex-wrap: wrap;width: 100%;justify-content: space-around;">
        <div *ngFor="let ticket of showcaseTickets; let i = index;" style="display: -webkit-flex; flex-direction: column; padding: 15px;width: 325px;margin-bottom: 15px;">
          <div class="ticket_container" (click)="selectTicket('showcase', ticket)" style="background-color: #D7BE69;color: black;font-weight: bold;">
            <div class="bd-border_dotted"></div>
            <div class="order-number-container">
              <div class="order-number">{{ ticket.OrderID }}</div>
            </div>
            <div class="bd-border_solid"></div>
            <div>{{ ticket.Name }}</div>
            <div style="font-size: 10px; margin-top: 5px">
              <p>Showcase Movie</p>
            </div>
            <div style="font-size: 10px; margin-top: 5px">
              Venue -
              <p>{{ ticket.VenueName }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- screening parties ticket -->
      <div *ngIf="screeningPartiesTickets.length > 0" class="showcase-heading">
        <h2>Screening Parties</h2>
      </div>
      <div *ngIf="screeningPartiesTickets.length > 0" style="flex-shrink:0;display:-webkit-flex; flex-wrap: wrap;width: 100%;justify-content: space-around;">
        <div *ngFor="let ticket of screeningPartiesTickets; let i = index;"
          style="display: -webkit-flex; flex-direction: column; padding: 15px;width: 325px;margin-bottom: 15px;">
          <div class="ticket_container" (click)="selectTicket('screeningParties', ticket)"
            style="background-color: #D7BE69;color: black;font-weight: bold;">
            <div class="bd-border_dotted"></div>
            <div class="order-number-container">
              <div class="order-number">{{ticket.cinejoyFeaturedMovieList[0][0].id}}</div>
            </div>
            <div class="bd-border_solid"></div>
            <div>{{ ticket.cinejoyFeaturedMovieList[0][0].name}}</div>
            <div> {{ ticket.firstName }} {{ ticket.lastName }}</div>
            <div style="font-size: 10px; margin-top: 5px">
              <p>Screening Party</p>
            </div>
            <div style="font-size: 10px; margin-top: 5px">
              {{ticket.ScreeningPartyDate | date:'MMM dd, yyyy h:mm:ss a'}} {{userTimezoneNameSP(ticket.ScreeningPartyDate)}}
            </div>
            <div style="font-size: 10px; margin-top: 5px">
              Venue -
              <p>{{ticket.meetingType}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
  </div>
  <div class="modal-footer custom-modal-footer">
    <button style='background: #DE1B36 !important; float: right; border: 1px red solid;'
      class="btn btn-warning modalOkButton" type="button" (click)="closeModal()">Close</button>
  </div>
</div>
